import { cloneDeep } from 'lodash';
import { validateJson } from '../../jsonParsing/jsonValidation/jsonValidation';
import { init_AdditionalNode } from './additionalNodes';
import {
  init_SignInComponent,
  init_DefaultComponent,
  init_Flowchart,
  init_AADReadComponent,
  init_AADUpdateComponent,
  init_AADCreateComponent,
  init_ConditionalComponent,
  init_UsernamePasswordValidation,
  init_UserInputPageComponent,
  init_ValidateMagicLink,
  init_TokenIssuer,
  init_RESTAPIComponent,
  init_MFAAuth,
  init_WebAuthnRegistration,
  init_WebAuthnAuthentication,
  init_WebAuthnCredentialsExist,
  init_WebAuthnAvailability,
  init_ConditionalAccessEvaluation,
  init_ConditionalAccessRemediation,
  init_ErrorPage as init_ErrorPage,
  init_AppInsightsComponent,
  init_UserInfoIssuer,
  init_AuthorizeToken,
  init_SendEmailOTP,
  init_SessionExists,
  init_oidcIdP,
  init_samlIdP,
  init_validationError,
  init_setClaims,
} from './init_components';
import jsonConstants from '../../constants/jsonConstants';
import defaultEnvs from '../../constants/defaultEnvs';
import { notDeepEqual } from 'assert';
// import { appInsights } from '../../appInsights.js';
// import { SeverityLevel } from '@microsoft/applicationinsights-web';

// export const sendAIAnalyticsTrace = (
//   message: string,
//   action: string,
//   furtherProperties: { [index: string]: string },
// ) => {
//   let sendProperties: { [index: string]: string } = {};
//   Object.keys(furtherProperties).forEach((k) => {
//     sendProperties[k] = furtherProperties[k];
//   });
//   sendProperties['analyticAction'] = action;
//   appInsights.trackTrace({
//     message: message,
//     severityLevel: SeverityLevel.Information,
//     properties: sendProperties,
//   });
// };

export const selectedLinks: any = (links: any) => {
  return Object.keys(links).reduce((acc: any, curVal: string) => {
    if (![true, false].includes(links[curVal])) {
      return acc.concat(selectedLinks(links[curVal]));
    } else if (links[curVal] === true) {
      return acc.concat(curVal);
    } else return acc;
  }, []);
};

export const testValidateJSON = (jsonEditor: any, allFlowcharts: any) => {
  const errReports = validateJson(jsonEditor);
  const _res: any = {
    claim: {},
  };
  if (errReports.length > 0) {
    errReports.forEach((errReport: any) => {
      if (errReport.reportType === 'node') {
        // @ts-ignore
        const allNodes: any = allFlowcharts[errReport.flowId]['nodes'];
        if (_res.hasOwnProperty(errReport.flowId)) {
          // flowchart error exists
          _res[errReport.flowId!]['components'][errReport.nodeId!] = {
            id: errReport.nodeId,
            name: allNodes.filter((node: any) => node.id === errReport.nodeId)[0]['data']['label'],
            componentType: errReport.componentType,
            errors: errReport.errors,
            warnings: errReport.warnings,
          };
        } else {
          // flowchart error does not exists
          _res[errReport.flowId!] = {
            id: errReport.flowId,
            displayName: errReport.flowDisplayName,
            components: {
              [errReport.nodeId!]: {
                id: errReport.nodeId,
                name: allNodes.filter((node: any) => node.id === errReport.nodeId)[0]['data']['label'],
                componentType: errReport.componentType,
                errors: errReport.errors,
                warnings: errReport.warnings,
              },
            },
          };
        }
      } else if (errReport.reportType === 'claim') {
        // @ts-ignore
        _res['claim'][errReport.claimId] = {
          errors: errReport.errors,
          warnings: errReport.warnings,
        };
      }
    });
    return _res;
  } else {
    return _res;
  }
};

export const addLinksForSignIn: any = () => { };

const additionalComponents: { [type: string]: CallableFunction } = {};

export const addAdditionComponentInitFunction = (type: string, initFunction: CallableFunction) => {
  additionalComponents[type] = initFunction
}

export const getInitComponent = (type: string) => {
  switch (type) {
    case 'signIn':
      return init_SignInComponent();
    case 'aadRead':
      return init_AADReadComponent();
    case 'aadUpdate':
      return init_AADUpdateComponent();
    case 'aadCreate':
      return init_AADCreateComponent();
    case 'conditionals':
      return init_ConditionalComponent();
    case 'usernamePasswordValidation':
      return init_UsernamePasswordValidation();
    case 'userInputPage':
      return init_UserInputPageComponent();
    case 'restAPI':
      return init_RESTAPIComponent();
    case 'validateMagicLink':
      return init_ValidateMagicLink();
    case 'tokenIssuer':
      return init_TokenIssuer();
    case 'userInfoIssuer':
      return init_UserInfoIssuer();
    case 'mfa':
      return init_MFAAuth();
    case 'webAuthnRegistration':
      return init_WebAuthnRegistration();
    case 'webAuthnAuthentication':
      return init_WebAuthnAuthentication();
    case 'webAuthnCredentialsExist':
      return init_WebAuthnCredentialsExist();
    case 'webAuthnAvailability':
      return init_WebAuthnAvailability();
    case 'conditionalAccessEvaluation':
      return init_ConditionalAccessEvaluation();
    case 'conditionalAccessRemediation':
      return init_ConditionalAccessRemediation();
    case 'errorPage':
      return init_ErrorPage();
    case 'appInsights':
      return init_AppInsightsComponent();
    case 'authorizeToken':
      return init_AuthorizeToken();
    case 'sendEmailOTP':
      return init_SendEmailOTP();
    case 'sessionExists':
      return init_SessionExists();
    case 'oidcIdP':
      return init_oidcIdP();
    case 'samlIdP':
      return init_samlIdP();
    case 'validationError':
      return init_validationError();
    case 'setClaims':
      return init_setClaims();
    default:
      const additNode = init_AdditionalNode(type);
      if (additNode) {
        return additNode
      }
      return init_DefaultComponent();
  }
};

export const countAndPluralization = (count: number, plural: string, singular: string) => {
  if (count == 1) {
    return `${count} ${singular}`;
  } else {
    return `${count} ${plural}`;
  }
};

export const formatXML = (xmlString: string) => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "application/xml");
  return new XMLSerializer().serializeToString(xmlDoc.documentElement);
}

export const subflowTypeLabels = {
  'formSubmitAction': 'Submit action',
  'userInfoEndpoint': 'User Info Endpoint',
  'emailVerificationSendAction': 'Custom Email Verification'
}

export const getSubflowDisplayLabel = (flowcharts: any, flowchartId: string, nodeId: string, sType: string) => {
  if (sType === 'userInfoEndpoint') {
    return subflowTypeLabels[sType]
  } else {
    return (subflowTypeLabels[sType as keyof typeof subflowTypeLabels] ?? '') + ' ' + (extractComponentLabel(flowcharts, flowchartId, nodeId) ?? '')
  }
}

export const extractComponentLabel: (flowcharts: any, flowchartId: string, nodeId: string) => string | undefined = (flowcharts: any, flowchartId: string, nodeId: string) => {
  return flowcharts[flowchartId].nodes.find((nd: any) => { return nd.id === nodeId; })?.data['label'];
}

export const getActiveDefaultEnvironments = () => {
  return Object.keys(jsonConstants.defaultEnvMap).reduce((envs: { [envId: string]: any }, defaultEnvKey) => { if (jsonConstants[defaultEnvKey as keyof typeof jsonConstants]) { envs[jsonConstants.defaultEnvMap[defaultEnvKey as keyof typeof jsonConstants.defaultEnvMap]] = cloneDeep(defaultEnvs[jsonConstants.defaultEnvMap[defaultEnvKey as keyof typeof jsonConstants.defaultEnvMap] as keyof typeof defaultEnvs]) }; return envs; }, {});
}

const copyNewlyTemplatizableField = (newState: any, nodeId: string, fieldPath: string) => {
  newState.nodeData[nodeId][fieldPath] = { value: newState.nodeData[nodeId][fieldPath], templatized: false }
}

const copyNewlyTemplatizableFields = (newState: any, nodeId: string, fieldPaths: string[]) => {
  fieldPaths.forEach((nField) => {
    newState.nodeData[nodeId][nField] = { value: newState.nodeData[nodeId][nField], templatized: false };
  });
}

const updateJsonToVersion1 = (jsonEditorState: any) => {
  let _newState = cloneDeep(jsonEditorState);
  // Need to add templatizations with default environments
  _newState.templatization = {
    templateFields: Object.keys(jsonConstants.defaultAppSettingFields).reduce((tfs: any, defField) => { tfs[defField] = { id: defField, name: defField, nodeFields: {} }; return tfs; }, {}),
    environments: Object.keys(jsonConstants.defaultEnvMap).reduce((envs: { [envId: string]: any }, defaultEnvKey) => { if (jsonConstants[defaultEnvKey as keyof typeof jsonConstants]) { envs[jsonConstants.defaultEnvMap[defaultEnvKey as keyof typeof jsonConstants.defaultEnvMap]] = cloneDeep(defaultEnvs[jsonConstants.defaultEnvMap[defaultEnvKey as keyof typeof jsonConstants.defaultEnvMap] as keyof typeof defaultEnvs]) }; return envs; }, {}),
    templatedComponents: {}
  }
  // Need to add default templatized fields on new required fields for token issuers and authorize token components
  // This is mostly to make old templates work correctly out-of-the-box.
  // Also need to properly box fields that have become templatizable (while marking them non-templatized).
  Object.keys(_newState.flowcharts).forEach((fcId: string) => {
    _newState.flowcharts[fcId].nodes.forEach((nd: any) => {
      if (_newState.nodeData[nd.id]) { // Sometimes 'ghost nodes' exist in JSON with no node data from deleted items; ignore these
        switch (_newState.nodeData[nd.id].componentType) {
          case 'tokenIssuer':
            if (_newState.nodeData[nd.id].protocol === 'saml') {
              _newState.nodeData[nd.id].issuerUri = { value: jsonConstants.defaultAppSettingFields.defaultSamlIssuerId, templatized: true };
              _newState.templatization.templatedComponents[nd.id] = { settings: [jsonConstants.defaultAppSettingFields.defaultSamlIssuerId.id], flowchart: fcId };
              _newState.templatization.templateFields[jsonConstants.defaultAppSettingFields.defaultSamlIssuerId.id].nodeFields[nd.id] = { nodeId: nd.id, fieldPaths: ['issuerUri'] };
            }
            break;
          case 'authorizeToken':
            _newState.nodeData[nd.id].oidcApplicationId = { value: jsonConstants.defaultAppSettingFields.oidcTestApplicationId.id, templatized: true }
            _newState.templatization.templatedComponents[nd.id] = { settings: [jsonConstants.defaultAppSettingFields.oidcTestApplicationId.id], flowchart: fcId };
            _newState.templatization.templateFields[jsonConstants.defaultAppSettingFields.oidcTestApplicationId.id].nodeFields[nd.id] = { nodeId: nd.id, fieldPaths: ['oidcApplicationId'] };
            break;
          case 'appInsights':
            copyNewlyTemplatizableField(_newState, nd.id, 'instrumentationKey');
            break;
          case 'errorPage':
            copyNewlyTemplatizableField(_newState, nd.id, 'contentDefinition');
            break;
          case 'mfa':
            copyNewlyTemplatizableField(_newState, nd.id, 'contentDefinition');
            break;
          case 'oidcIdP':
            copyNewlyTemplatizableFields(_newState, nd.id, [
              'idpDomain',
              'metadataUrl',
              'authEndpointUrl',
              'endSessionEndpointUrl',
              'clientId',
              'clientSecretContainerName'
            ]);
            break;
          case 'restAPI':
            copyNewlyTemplatizableField(_newState, nd.id, 'serviceUrl');
            break;
          case 'samlIdP':
            copyNewlyTemplatizableFields(_newState, nd.id, [
              'idpDomain',
              'metadataUrl',
              'messageSigningKey',
              'assertionDecryptionKey',
              'metadataSigningKey'
            ]);
            break;
          case 'signIn':
            copyNewlyTemplatizableField(_newState, nd.id, 'contentDefinition');
            break;
          case 'userInputPage':
            copyNewlyTemplatizableField(_newState, nd.id, 'contentDefinition');
            break;
          case 'webAuthnAuthentication':
            copyNewlyTemplatizableField(_newState, nd.id, 'contentDefinition');
            break;
          case 'webAuthnRegistration':
            copyNewlyTemplatizableField(_newState, nd.id, 'contentDefinition');
            break;
          case 'webAuthnAvailability':
            copyNewlyTemplatizableField(_newState, nd.id, 'contentDefinition');
            break;
          case 'webAuthnCredentialsExist':
            copyNewlyTemplatizableField(_newState, nd.id, 'contentDefinition');
            break;
          default:
            break; // Component type didn't have any fields become templatizable in version 1
        }
      }
    })
  })
  // Add version tag
  _newState.jsonSchemaVersion = '1';
  return _newState;
}

const updateJsonVerson1to2 = (jsonEditorState: any) => {
  let _newState = cloneDeep(jsonEditorState);
  // Version 2 introduces REST API authentications
  // Need to convert empty or legacy 'open' field values to 'none'
  // and add templatizable fields for auth-type-specific info.
  Object.keys(_newState.flowcharts).forEach((fcId: string) => {
    _newState.flowcharts[fcId].nodes.forEach((nd: any) => {
      if (_newState.nodeData[nd.id] && _newState.nodeData[nd.id].componentType === 'restAPI') {
        if ((!_newState.nodeData[nd.id].authenticationType) || (_newState.nodeData[nd.id].authenticationType === 'open')) {
          _newState.nodeData[nd.id].authenticationType = 'none';
        }
        _newState.nodeData[nd.id].clientIdContainer = { value: '', templatized: false }
        _newState.nodeData[nd.id].clientSecretContainer = { value: '', templatized: false }
        _newState.nodeData[nd.id].clientCertContainer = { value: '', templatized: false }
        _newState.nodeData[nd.id].applicationIdUri = { value: '', templatized: false }
        _newState.nodeData[nd.id].issuerTenant = { value: '', templatized: false }
      }
    });
  });

  _newState.jsonSchemaVersion = '2'
  return _newState
}

const jsonMigrationImplMap: { [toVersion: string]: { migration: Function, nextVer: string } } = {
  '1': { migration: updateJsonVerson1to2, nextVer: '2' },
}

export const getMigratedJson = (jsonEditorState: any) => {
  let version = jsonEditorState['jsonSchemaVersion'];
  let curState = jsonEditorState;
  if (!version) { // Pre-versioned JSON schema. Attempt to update to version 1 first.
    curState = updateJsonToVersion1(curState);
    version = curState['jsonSchemaVersion'];
  }
  while ((version !== jsonConstants.editorJsonSchemaVersion) && (Object.keys(jsonMigrationImplMap).includes(version)) && (jsonMigrationImplMap[version].nextVer)) {
    curState = jsonMigrationImplMap[version].migration(curState);
    version = curState['jsonSchemaVersion'];
  }
  return curState;
}

export const getDefaultDeploymentEnv = (allEnvironments: any) => {
  return (jsonConstants.enableGritDevEnvDefaultEnv
    && Object.keys(allEnvironments).includes(jsonConstants.defaultEnvMap['enableGritDevEnvDefaultEnv'])
  ) ? jsonConstants.defaultEnvMap['enableGritDevEnvDefaultEnv']
    : ((jsonConstants.enableGritSandboxDefaultEnv
      && Object.keys(allEnvironments).includes(jsonConstants.defaultEnvMap['enableGritSandboxDefaultEnv'])
    ) ? jsonConstants.defaultEnvMap['enableGritSandboxDefaultEnv']
      : ((Object.keys(allEnvironments).length > 0) ? Object.keys(allEnvironments)[0] : '')
    );
}

export const validationResultsContainErrors = (validationResults: any) => {
  return (((validationResults?.claim) && (Object.keys(validationResults.claim).some((cId) => {
    return (validationResults.claim[cId].errors.length > 0)
  }))) || ((validationResults) && (Object.keys(validationResults).some((vrId) => {
    return ((vrId !== 'claim')
      && (validationResults[vrId]?.components)
      && (Object.keys(validationResults[vrId].components).some((comId) => {
        return validationResults[vrId].components[comId]?.errors?.length > 0
      }))
    )
  }))))
}

export const envExists = (editorState: any, envId: string) => {
  return Object.keys(editorState.templatization.environments).includes(envId);
}

export const envHasEmptySettings = (editorState: any, envId: string) => {
  return Object.keys(editorState.templatization.templateFields).some((ke) => {
    return (!editorState.templatization.environments[envId].settings[ke]);
  })
}
